import {Component} from "react";

class PageNotFound extends Component {
    render() {
        return (<div>Page Not Found</div>);
    }
}
export default PageNotFound;
